/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { CalendarDays, House, LucideIcon, MapPinned, ShoppingCart, Sprout } from "lucide-react";

import { TestIds } from "../../../testIds";
import { NavDestination, NavDestinationId, useNavDestinations } from "../hooks/useNavDestinations";

type SideNavItemConfig = {
  destinationId: NavDestinationId;
  label: string;
  icon: LucideIcon;
  testId?: string;
};

/**
 * Side nav's own presentation config — order, label, and icon are all decided
 * here and only here.
 */
const SIDE_NAV_CONFIG: SideNavItemConfig[] = [
  { destinationId: "home", label: "Home", icon: House, testId: TestIds.components.sideDrawer.home },
  {
    destinationId: "shop",
    label: "Shop",
    icon: ShoppingCart,
    testId: TestIds.components.sideDrawer.pastProducts,
  },
  {
    destinationId: "agreements",
    label: "Agreements",
    icon: CalendarDays,
    testId: TestIds.components.sideDrawer.agreements,
  },
  {
    destinationId: "cardPartners",
    label: "Partners",
    icon: MapPinned,
    testId: TestIds.components.sideDrawer.cardPartners,
  },
  {
    destinationId: "seed",
    label: "Seed",
    icon: Sprout,
    testId: TestIds.components.sideDrawer.seed,
  },
];

export type SideNavItem = SideNavItemConfig & NavDestination;

export const useSideNavItems = (): SideNavItem[] => {
  const destinations = useNavDestinations();

  return SIDE_NAV_CONFIG.filter((item) => destinations[item.destinationId].visible).map((item) => ({
    ...item,
    ...destinations[item.destinationId],
  }));
};
